import * as React from "react";
import { alpha, Divider, ListItemButton, ListItemIcon, ListItemText, Typography } from "@mui/material";
import { Link, useLocation } from "react-router-dom";
import { useStudentSubjectSelectionStatus } from "../../hooks/useStudentSubjectSelectionStatus";
import HomeOutlinedIcon from "@mui/icons-material/HomeOutlined";
import ExitToAppIcon from "@mui/icons-material/ExitToApp";
import AccountCircleOutlinedIcon from "@mui/icons-material/AccountCircleOutlined";
import AnnouncementOutlinedIcon from "@mui/icons-material/AnnouncementOutlined";
import ClassOutlinedIcon from "@mui/icons-material/ClassOutlined";
import AssignmentOutlinedIcon from "@mui/icons-material/AssignmentOutlined";
import GradingOutlinedIcon from "@mui/icons-material/GradingOutlined";
import FolderSharedOutlinedIcon from "@mui/icons-material/FolderSharedOutlined";
import AccountBalanceOutlinedIcon from "@mui/icons-material/AccountBalanceOutlined";
import {
    isStudentHomePath,
    isStudentResultsPath,
    STUDENT_HOME,
} from "../../utils/studentPortalPaths";
import { useCloseMobileNav } from "../../components/DashboardLayoutContext";

function NavItem({ to, label, Icon, selected }) {
    const closeMobileNav = useCloseMobileNav();
    return (
        <ListItemButton
            component={Link}
            to={to}
            selected={selected}
            onClick={closeMobileNav}
            sx={{
                borderRadius: 1.5,
                mx: 1,
                mb: 0.35,
                "&.Mui-selected": {
                    bgcolor: (t) => alpha(t.palette.primary.main, 0.1),
                },
            }}
        >
            <ListItemIcon>
                <Icon fontSize="small" color={selected ? "primary" : "inherit"} />
            </ListItemIcon>
            <ListItemText primary={label} primaryTypographyProps={{ variant: "body2", fontWeight: selected ? 700 : 500 }} />
        </ListItemButton>
    );
}

const StudentSideBar = () => {
    const { pathname } = useLocation();
    const { needsSelection: showForm3Choice } = useStudentSubjectSelectionStatus();

    return (
        <>
            <Typography variant="caption" color="text.secondary" sx={{ px: 2, pt: 0.5, fontWeight: 600 }}>
                Student
            </Typography>
            <NavItem to={STUDENT_HOME} label="Home" Icon={HomeOutlinedIcon} selected={isStudentHomePath(pathname)} />
            <NavItem
                to="/Student/results"
                label="Results"
                Icon={GradingOutlinedIcon}
                selected={isStudentResultsPath(pathname)}
            />
            <NavItem
                to="/Student/subjects"
                label="Subjects"
                Icon={AssignmentOutlinedIcon}
                selected={pathname.startsWith("/Student/subjects")}
            />
            {showForm3Choice ? (
                <NavItem
                    to="/Student/form3-subjects"
                    label="Choose subjects"
                    Icon={AssignmentOutlinedIcon}
                    selected={pathname.startsWith("/Student/form3-subjects")}
                />
            ) : null}
            <NavItem
                to="/Student/resources"
                label="Resources"
                Icon={FolderSharedOutlinedIcon}
                selected={pathname.startsWith("/Student/resources")}
            />
            <NavItem
                to="/Student/fees"
                label="Fees"
                Icon={AccountBalanceOutlinedIcon}
                selected={pathname.startsWith("/Student/fees")}
            />
            <NavItem
                to="/Student/attendance"
                label="Attendance"
                Icon={ClassOutlinedIcon}
                selected={pathname.startsWith("/Student/attendance")}
            />
            <NavItem
                to="/Student/complain"
                label="Complaints"
                Icon={AnnouncementOutlinedIcon}
                selected={pathname.startsWith("/Student/complain")}
            />
            <Divider sx={{ my: 1, mx: 2 }} />
            <Typography variant="caption" color="text.secondary" sx={{ px: 2, fontWeight: 600 }}>
                Account
            </Typography>
            <NavItem
                to="/Student/profile"
                label="Profile"
                Icon={AccountCircleOutlinedIcon}
                selected={pathname.startsWith("/Student/profile")}
            />
            <NavItem to="/logout" label="Log out" Icon={ExitToAppIcon} selected={pathname.startsWith("/logout")} />
        </>
    );
};

export default StudentSideBar;
